/** Projeções usadas nos mapas OpenLayers (view em Web Mercator). */
export const WGS84 = 'EPSG:4326'
export const WEB_MERCATOR = 'EPSG:3857'

/**
 * GeoJSON vindo da API cadastral/geo: armazenado em EPSG:31982 no PostGIS,
 * exportado em WGS84 (EPSG:4326) para exibição no mapa (EPSG:3857).
 */
export function geoJsonReadOptions(featureProjection = WEB_MERCATOR) {
    return {
        dataProjection: WGS84,
        featureProjection,
    }
}
